import { storyblokEditable } from '@storyblok/react/rsc';
import StoryblokRichText from '@/components/StoryblokRichText';
import PhosphorIcon from '@/components/PhosphorIcon';
import { colorStyle, styleOverrides } from '@/lib/helpers';

const ServiceCard = ({ blok }) => {
  const radius = blok.border_radius || 'rounded-[0.5rem]';
  // White is the default service-card background; an editor pick overrides it.
  const style = { ...colorStyle(blok, { into: { backgroundColor: '#FFFFFF' } }), ...styleOverrides(blok) };

  return (
    <div
      {...storyblokEditable(blok)}
      className={`${radius} p-6 sm:p-8 shadow-card flex flex-col gap-4`}
      style={style}
    >
      {blok.icon && (
        <PhosphorIcon name={blok.icon} size={32} />
      )}
      {blok.title && (
        <p className="text-18 font-bold">{blok.title}</p>
      )}
      {blok.description?.content?.[0] && (
        <StoryblokRichText content={blok.description} className="text-16" />
      )}
      {(blok.price || blok.original_price) && (
        <div className="mt-auto flex flex-wrap items-baseline gap-2">
          {blok.original_price && (
            <span className="text-16 line-through opacity-70">{blok.original_price}</span>
          )}
          {blok.price && (
            <strong className="text-24 font-extrabold">{blok.price}</strong>
          )}
          {blok.price_suffix && (
            <span className="text-14">{blok.price_suffix}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceCard;
